<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';

import Countdown from '@/shared/components/UI/Countdown.vue';

const props = defineProps<{
  cardClasses: string;
  endDate: string;
}>();

const rootRef = useTemplateRef('rootRef');

const distance = ref(new Date(props.endDate).getTime() - Date.now());
const showCountdownBanner = ref(true);

const handleCountdownDone = () => {
  showCountdownBanner.value = false;

  //let the liquid section know that the countdown is done
  const event = new CustomEvent('time-is-up');
  rootRef.value?.$el?.parentElement.dispatchEvent(event);
};
</script>

<template>
  <Countdown
    v-if="showCountdownBanner"
    ref="rootRef"
    :distance="distance"
    :time-unit-classes="cardClasses"
    :use-short-time-units="true"
    :avoid-hiding-time-units="true"
    value-classes="text-3xl font-bold md:text-4xl lg:text-5xl"
    @done="handleCountdownDone"
  />
</template>
